import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityClassicRoute: InvariantJiraRoute = {
	name: 'software-capacity-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/:view(people|work)?',
	query: [],
};
